import { jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from '@mui/material';
import { ArrayAttribute } from './ArrayAttribute';
import { BitmapAttribute } from './BitmapAttribute';
import { BooleanAttribute } from './BooleanAttribute';
import { EnumerationAttribute } from './EnumerationAttribute';
import { NumberAttribute } from './NumberAttribute';
import { PresentAttribute } from './PresentAttribute';
export const AttributeModiferKeys = ['range', 'enumeration', 'start', 'end'];
export const Arbitrator = (props) => {
    const { rangeLimits } = props;
    switch (rangeLimits?.attributeType) {
        case 'present':
            return PresentAttribute(props);
        case 'boolean':
            return BooleanAttribute(props);
        case 'number':
            return NumberAttribute(props);
        case 'enumeration':
            return EnumerationAttribute(props);
        case 'bitmap':
            return BitmapAttribute(props);
        case 'array':
            return ArrayAttribute(props);
    }
    const json = !rangeLimits ? 'no range limits' : rangeLimits.attributeType ? JSON.stringify(rangeLimits.attributeType) : 'attribute type is not defined';
    const unsupported = (_jsxs(Alert, { severity: "error", sx: { paddingBlock: 0 }, children: ["Unsupported: ", json] }));
    return { elements: unsupported, payload: {}, valid: false };
};
